import { useCart } from "../../../../app/context/cart-context/cart-context";
import { useEffect, useState } from "react";

import "./quantity-selector.css";

import minus from '../../../../assets/images/icons/minus.svg';
import plus from '../../../../assets/images/icons/plus.svg';

export const QuantitySelector = ({ productId }) => {

    const {cart, updateCart} = useCart();

    const currentQuantity = cart.filter(item => item.id === productId);

    const [quantity, setQuantity] = useState(currentQuantity[0]?.qty || 1);

    const increment = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setQuantity(prevQuantity => prevQuantity + 1);
    }

    const decrement = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setQuantity(prevQuantity => {
            if (prevQuantity > 1) {
                return prevQuantity - 1;
            }
            else
            {
                return prevQuantity = 0;
            }
            
        })
    }

    useEffect(() => {
        updateCart({id: productId, qty: quantity});
    }, [quantity]);
    
    
    return (
        <div className="quantity-selector-wrap">
            <button onClick={(e) => decrement(e)}>
                <img src={minus} alt="" />
            </button>
            <span className="qty-field" onClick={(e) => {e.preventDefault(); e.stopPropagation()}}>{quantity}</span>
            <button onClick={(e) => increment(e)}>
                <img src={plus} alt="" />
            </button>
            
        </div>
    )
}